import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPipesModule } from '../../shared-pipes';
import { CitationModule } from '../citation';
import { IconModule } from '../icon';
import { WrittenContentAnchorClickListenerModule } from '../listeners/written-content-anchor-click-listener';
import { LoadingModule } from '../loading';
import { ScorePanelImageDownloadButtonModule } from '../score-panel-image-download-button';
import { BodyItemComponent } from './body-item';
import { BodyItemFocusboxComponent } from './body-item-focusbox';
import { BodyItemDatawrapperComponent } from './body-item-datawrapper';
import { BodyItemExpandedImageComponent, BodyItemImageComponent } from './body-item-image';
import { BodyItemLopTableComponent } from './body-item-lop-table';
import { BodyItemParagraphComponent } from './body-item-paragraph';
import { BodyItemTableComponent } from './body-item-table';
import { BodyItemVideoComponent, BodyItemVideoPlayerComponent } from './body-item-video';
import { UpdateLinkPipe } from './pipes/update-link.pipe';

const components = [
  BodyItemComponent,
  BodyItemFocusboxComponent,
  BodyItemDatawrapperComponent,
  BodyItemExpandedImageComponent,
  BodyItemImageComponent,
  BodyItemLopTableComponent,
  BodyItemParagraphComponent,
  BodyItemTableComponent,
  BodyItemVideoComponent,
  BodyItemVideoPlayerComponent,
  UpdateLinkPipe,
];

@NgModule({
  imports: [
    CommonModule,
    WrittenContentAnchorClickListenerModule,
    CitationModule,
    LoadingModule,
    ScorePanelImageDownloadButtonModule,
    SharedPipesModule,
    IconModule,
    NgbTooltipModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class BodyItemModule {}
